import { Button, CircularProgress, Grid } from "@mui/material";
import React from "react";
import { IDisable, IMutator, IOptions } from "sonobello.utilities.react";

import { CustomDimension } from "../../../../Models/CustomDimension";

export const classNames = {
  option: "dispositionPickerOption",
  spinner: "dispositionPickerLoadSpinner"
};

export interface IDispositionPicker
  extends IDisable,
    IOptions<CustomDimension<number>>,
    IMutator<CustomDimension<number>> {
  /** An which should be rendered as loading, if any. */
  loadingOption: CustomDimension<number> | null;
}

/** A element which allows for the selection of a disposition from a given set of options. */
const DispositionPicker: React.FC<IDispositionPicker> = ({ disabled, options, loadingOption, onChange }) => {
  return (
    <Grid container spacing={1}>
      {options.map((type, index) => (
        <Grid item key={index} display="flex" alignItems="center" justifyContent="center">
          {type.id === loadingOption?.id ? (
            <CircularProgress className={classNames.spinner} size="1.7rem" sx={{ mx: 6 }} />
          ) : (
            <Button className={classNames.option} disabled={disabled} onClick={() => onChange(type)}>
              {type.name}
            </Button>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default DispositionPicker;
